export class NetworkSettingDto {
  descriptors: string[];
  id: string;
  isAutoApproveTransaction: boolean;
  networkType: string;

  constructor(d?: NetworkSettingDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
